import { render, staticRenderFns } from "./import-from-source.vue?vue&type=template&id=e20d94c0&scoped=true&"
import script from "./import-from-source.vue?vue&type=script&lang=js&"
export * from "./import-from-source.vue?vue&type=script&lang=js&"
import style0 from "./import-from-source.vue?vue&type=style&index=0&id=e20d94c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20d94c0",
  null
  
)

export default component.exports